interface IRouteFilterOptions {
	[key: string]: string | null;
}

const calculateSitemapPath = () => {
	const route = useRoute();
	let routeFilterOptions: IRouteFilterOptions = { A: "Home" };

	if (route.params.sportId) {
		const sportId: string = route.params.sportId as string;
		routeFilterOptions = { A: sportId };
	} else if (route.params.subLobby) {
		const subLobby: string = route.params.subLobby as string;
		routeFilterOptions = { A: subLobby };
	} else if (route.params.content) {
		const contentId: string = route.params.content as string;
		routeFilterOptions = { A: contentId };
	} else if (route.name === "index") {
		routeFilterOptions = { A: "Home" };
	} else if (route.name === "esports") {
		routeFilterOptions = { A: "esports" };
	} else if (route.name === "jackpots") {
		routeFilterOptions = { A: "jackpots" };
	} else if (route.name === "contact-us") {
		routeFilterOptions = { A: "contact-us" };
	} else {
		routeFilterOptions = { A: null };
	}

	return routeFilterOptions;
};

export default calculateSitemapPath;
